import React, { Component } from 'react';
import { Link } from 'react-router';
import ReactMarkdown from 'react-markdown';

import {} from './NewsArticle.css';

class NewsArticle extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 News Article";
        this.state = {
            item:this.props.location.state.item
        };
    
    }
    render() {
        return (
            <div className="container">
                <br/>
                <Link className="Article-news-link" to="/news">&lt; Back to News</Link>
                <p className="title">{this.state.item.title}</p>
                <p className="subtitle">{this.state.item.publisher}</p>
                <p>Keywords: {this.state.item.keywords}</p>
                <p>Original Article: <a className="Article-link" href={this.state.item.url} alt="Original Article" target="_blank">{this.state.item.url}</a></p>
                <hr/>
                <ReactMarkdown className="DisplayLinebreak" source={this.state.item.article} />
                <div> </div>
                <br/>
                
            </div>
        );
    }
}

export default NewsArticle;


// WEBPACK FOOTER //
// ./src/News/NewsArticle.js